import React, { useState, useRef, useCallback } from 'react';
import FilterSection from './FilterSection';
import VehicleInfoSection from './VehicleInfoSection';
import ParametersSection from './ParametersSection';
import styles from './MileageSimulatorTab.module.css';
import { decodeToken } from 'react-jwt';
import { API_URL_MAIN, INIT_FILTER_STATE_MILEAGE_SAARATHI } from '../../../../constants/driveglobalfilterinitalstates_bus';
import GlobalFilter from './GlobalFilter.js';

const MileageSimulatorTab = () => {

  const tokenNew = JSON.parse(sessionStorage.user);
  let decodedToken = decodeToken(tokenNew.token);
  const city_name = decodedToken.city_name;
  const city_name_arr = city_name.split(",");
  const depo_name = decodedToken.depo_name;
  const depo_name_arr = depo_name.split(",");
  let sampleObj = (city_name != "") ? { ...INIT_FILTER_STATE_MILEAGE_SAARATHI, CITY: city_name_arr, DEPO: depo_name_arr } : INIT_FILTER_STATE_MILEAGE_SAARATHI
  const [globalFilter, setGlobalFilter] = useState({ ...sampleObj })
  const [energyEfficiency, setEnergyEfficiency] = useState(0)
  const [distance, setDistance] = useState(0)

  const [selectedVin, setSelectedVin] = useState('GJ18BV3038');
  const [dateRange, setDateRange] = useState('27/06/2025 - 03/07/2025');
  const [toggleValue, setToggleValue] = useState('100');
  const [activeToggle, setActiveToggle] = useState('National');



  const filterSubmitted = useCallback((data) => {
    setGlobalFilter(data);
  }, []);

  return (
    <div className={`${styles.container} p-4`}>
      {/* Header */}
      <div className="mb-4">
        <h2 className={`${styles.header} fw-bold mb-4 text-start`}>
          Assess The Impact On Energy Efficiency
        </h2>
        {/* Filter Section */}
        {/* <div className=' card py-3 px-2'>

          <FilterSection
            // selectedVin={selectedVin}
            // setSelectedVin={setSelectedVin}
            // dateRange={dateRange}
            // setDateRange={setDateRange}
            onsubmit={filterSubmitted} setGlobalFilter={setGlobalFilter} gloablfilter={{ ...globalFilter }} setGloablfilter={setGlobalFilter}
          />
        </div> */}
      </div>
      <div>
        <GlobalFilter filterData={globalFilter} setGlobalFilter={setGlobalFilter} />
      </div>
      {/* Disclaimer */}
      <p className="text-muted fst-italic small mb-4 text-start">
        Simulated Energy efficiency and energy savings values are indicative and not actual.
      </p>
      {/* Vehicle Info Section */}
      <VehicleInfoSection
        setEnergyEfficiency={setEnergyEfficiency}
        filterdata={globalFilter}
        setDistance={setDistance}
      />
      {/* Parameters Section */}
      <div style={{ display: (globalFilter?.VIN_NUM?.length || globalFilter?.REG_NUM?.length) ? "" : "none" }}>
        <ParametersSection
          energyEfficiency={energyEfficiency}
          filterdata={globalFilter}
          distance={distance}
        />
      </div>
    </div>
  );
};

export default MileageSimulatorTab;